export const capitalize = (string) => {
  return string[0].toUpperCase() + string.slice(1);
};

export const formatBreadcrumb = (category, subcategory) => {
  return subcategory ? category + " > " + subcategory : category;
};

export const formatUrlFromMenu = (category, url, categories) => {
  url = url + "/";
  if (!category) {
    return url + "catalogue";
  }
  if (category.includes(" > ")) {
    return (
      url +
      categories.find((cat) => cat.name.toLowerCase() === category.split(" > ")[0])?.slug +
      "/" +
      category.split(" > ")[1]
    );
  } else {
    return url + categories.find((cat) => cat.name.toLowerCase() === category.split(" > ")[0])?.slug;
  }
};
